<template>
  <div class="instruction">
    <div class="instruction__inner">
      <div class="instruction__main">
        <BaseText
          v-if="text"
          :text="text"
          size="xl"
        />
        <BaseButton
          v-if="hasButton"
          :text="$t('actions.start')"
          class="instruction__button"
          @click="$emit('start')"
        />
      </div>
      <div class="instruction__side">
        <button
          type="button"
          class="instruction__play"
          @click="showModal"
        >
          <BaseIcon name="play" class="instruction__play-icon" />
          <BaseText
            v-if="label"
            :text="label"
            class="instruction__label"
            tag="span"
          />
        </button>
      </div>
    </div>
    <ModalVideo
      v-if="isModalVisible"
      :src="video"
      :has-progress="false"
      :has-play-button="false"
      class="screen__overlay"
      @close="onModalClose"
      @ended="onModalClose"
    />
  </div>
</template>

<script>
import BaseText from '@/components/BaseText.vue';
import BaseIcon from '@/components/BaseIcon.vue';
import BaseButton from '@/components/BaseButton.vue';
import ModalVideo from '@/components/ModalVideo.vue';

import CONSTANTS from '@/helpers/constants';

const {
  ACTION_PLAY,
} = CONSTANTS;

export default {
  name: 'Instruction',
  components: {
    BaseText,
    BaseIcon,
    BaseButton,
    ModalVideo,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    video: {
      type: String,
      default: '',
    },
    hasButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isModalVisible: false,
    };
  },
  computed: {
    label() {
      return this.$t('texts.videoLabel');
    },
  },
  created() {
    this.initActions();
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    hideModal() {
      this.isModalVisible = false;
    },
    sayText() {
      if (!this.text) return;
      this.$robot.dialogService.sayText(this.text, true);
    },
    onModalClose() {
      this.hideModal();
      this.sayText();
    },
    initActions() {
      const rootActions = [
        [ACTION_PLAY, this.showModal],
      ];

      rootActions.forEach((action) => this.$root.$on(...action));

      this.$once('hook:beforeDestroy', () => {
        rootActions.forEach((action) => this.$root.$off(...action));
      });
    },
  },
};
</script>

<style lang="stylus">
.instruction
  display block

  &__inner
    display flex
    width 100%
    height 100%

  &__side
  &__main
    flex-grow 1
    flex-basis 0
    max-width 50%

  &__main
    align-self center
    padding-right 2em

  &__button
    margin-top 2em

  &__play
    position relative
    width 100%
    height 100%
    background $c_text
    display flex
    flex-flow row wrap
    align-items center
    justify-content center
    text-align center
    color #fff
    outline none
    border 0

  &__play-icon
    width 5em
    height 5em

  &__label
    display block
    abs bottom left right
    padding 2em
</style>
